(() => { const controllers=new WeakMap(); function initialize(root){controllers.get(root)?.abort();const controller=new AbortController();controllers.set(root,controller);const listen=(target,type,callback,options={})=>target.addEventListener(type,callback,{...options,signal:controller.signal});
const revealHint = root.querySelector('#reveal-hint');
function updateHint() {
  revealHint.textContent = window.matchMedia('(hover: none)').matches ? 'Tap to reveal' : 'Hover to reveal';
}
if (revealHint) updateHint();
if (revealHint) listen(window.matchMedia('(hover: none)'), 'change', updateHint);

root.querySelectorAll('.talent-card').forEach(card => {
  listen(card, 'pointerenter', event => {
    if (event.pointerType === 'mouse') card.setAttribute('aria-pressed', 'true');
  });
  listen(card, 'click', () => {
    card.setAttribute('aria-pressed', String(card.getAttribute('aria-pressed') !== 'true'));
  });
});

const video = root.querySelector('video');
const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
function forceMuted() {
  if (!video) return;
  video.muted = true;
  video.defaultMuted = true;
  video.volume = 0;
}
if(video) listen(video, 'play', () => {
  forceMuted();
  if (reducedMotion.matches || document.hidden) video.pause();
});
function updateVideo() {
  if (!video) return;
  forceMuted();
  if (reducedMotion.matches || document.hidden) video.pause();
  else video.play().catch(() => { video.controls = true; });
}
listen(reducedMotion, 'change', updateVideo);
listen(document, 'visibilitychange', updateVideo);
updateVideo();


}
document.querySelectorAll('.shopify-section').forEach(initialize);document.addEventListener('shopify:section:load',e=>initialize(e.target));document.addEventListener('shopify:section:unload',e=>controllers.get(e.target)?.abort());})();